import e from "../assets/E.png";
import Run from "../assets/Run.png";

import yoga from "../assets/yogateachers.jpg";
import kids from "../assets/kids.png";
import karate from "../assets/MonkBg.jpg";
import karateMonk from "../assets/Monk.png";
import adults from "../assets/adults.png";
import badminton from "../assets/batcourt.png";
export const BadmintonAcademy = () => {
  return (
    <div
      id="otheractivities"
      className="relative w-full min-h-screen border-none bg-black overflow-hidden text-white"
    >
      <div className="absolute  inset-0 top-0 flex justify-center items-center z-0">
        <img
          src={e}
          alt="E Background"
          className=" w-full xl:h-[70%] mb-24   xl:mt-[280px] hidden lg:block"
        />
      </div>
      <div className="absolute top-20 xl:top-16 left-6 md:left-16 z-20">
        <p className="text-white font-league uppercase text-3xl md:text-5xl lg:text-[70px] xl:text-[120px] leading-none">
          Why at Kosmos <br /> Badminton Academy?
        </p>
      </div>
      <div className="absolute left-[80px] md:left-[300px] lg:left-[400px] xl:left-[600px] top-8 xl:top-4 z-10 overflow-hidden">
        <img
          src={Run}
          alt="Athlete"
          className="w-[400px] md:w-[600px] lg:w-[800px] xl:w-[1200px]  "
        />
      </div>
      <div className="relative z-20 mt-[250px] md:mt-[300px] lg:mt-[300px] xl:mt-[400px]  lg:pr-16  mb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-stretch">
          <div className="col-span-1 lg:col-span-2 flex flex-col h-full">
            <div className="mt-auto pl-2 md:pl-12 pr-2 md:pr-0">
              <div className="text-left ">
                <p className="font-langit tracking-wide text-[12px] lg:text-[14px] xl:text-[17px] text-white">
                  YOGA STUDIO
                </p>
                <p className="text-[12px] xl:text-[13px] text-gray-300 font-articulat tracking-wide leading-relaxed my-2 ">
                  Spacious studio for Hatha, Vinyasa ＆ Power Yoga — perfect for
                  flexibility and stress relief.
                </p>
              </div>
              <div className="relative w-full ms:h-[300px] mm:h-[400px]  md:h-[400px]">
                <img
                  src={yoga}
                  alt="Yoga Background"
                  className="rounded-lg w-full h-full md:object-cover "
                />
              </div>
            </div>
          </div>

          <div className="col-span-1 lg:col-span-2 flex flex-col h-full px-2 md:px-0 md:pr-16 lg:pr-0 ">
            <div className="mt-auto">
              <div className="text-left mx-auto pl-6 md:pl-0">
                <p className="font-langit tracking-wide text-[12px] lg:text-[14px] xl:text-[17px] text-white uppercase">
                  BAdminton coaching for kids
                </p>
                <p className="text-[12px] xl:text-[13px] tracking-wide text-gray-300 font-articulat leading-relaxed my-2">
                  Fast‑paced table tennis to boost skill, reflexes, and
                  cross-train with badminton.
                </p>
              </div>
              <img
                src={kids}
                alt="Table Tennis"
                className="rounded-lg w-full h-[200px] object-cover"
              />
            </div>
          </div>

          <div className="col-span-1 lg:col-span-4 flex flex-col h-full px-2 md:px-0">
            <div className="mt-auto md:pl-16 lg:pl-0">
              <div className="text-left  pl-6 md:pl-0">
                <p className="font-langit tracking-wide text-[12px] lg:text-[14px] xl:text-[17px] text-white">
                  KARATE DOJO
                </p>
                <p className="text-[12px] xl:text-[13px] tracking-wide text-gray-300 font-articulat leading-relaxed mt-2 mb-16">
                  Traditional martial arts for all ages— builds discipline,
                  strength,
                  <br />
                  and focus.
                </p>
              </div>
              <div className="relative w-full h-[300px]">
                <img
                  src={karate}
                  alt="Karate"
                  className="rounded-lg w-full h-full object-cover"
                />
                <img
                  src={karateMonk}
                  alt="Karate Monk"
                  className="absolute bottom-0 left-0 -translate-x-1/2 h-[473px] w-full object-cover drop-shadow-lg"
                  style={{ zIndex: 2 }}
                />
              </div>
            </div>
          </div>

          <div className="col-span-1 lg:col-span-2 flex flex-col h-full px-2 md:px-0">
            <div className="mt-auto md:pr-16 lg:pr-0">
              <div className="text-left pl-6 md:pl-0">
                <p className="font-langit tracking-wide text-[12px] lg:text-[14px] xl:text-[16px] text-white uppercase">
                  Badminton coaching for adults
                </p>
                <p className="text-[12px] xl:text-[13px] text-gray-300 font-articulat tracking-wide leading-relaxed my-2">
                  Fully equipped gym with free weights for strength and athletic
                  performance.
                </p>
              </div>
              <img
                src={adults}
                alt="Gym"
                className="rounded-lg w-full h-[200px] object-cover"
              />
            </div>
          </div>

          <div className="col-span-1 md:col-span-2 flex flex-col h-full px-2 md:px-16 lg:px-0 ">
            <div className="mt-auto ">
              <div className="text-left pl-6 md:pl-0">
                <p className="font-langit tracking-wide text-[12px]lg:text-[14px] xl:text-[17px] text-white ">
                  BADMINTON COURTS
                </p>
                <p className="text-[12px] xl:text-[13px] text-gray-300 font-articulat tracking-wide leading-relaxed my-2">
                  Clean courts, certified flooring, and expert coaching for all
                  ages—from beginners to pros.
                </p>
              </div>
              <img
                src={badminton}
                alt="Badminton"
                className="rounded-lg w-full h-[350px] object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
